import {useEffect} from 'react';
import useTypedDispatch from '../common/useTypedDispatch';
import {setIsUpdated as setIsTodayGiftUpdated} from '../domain/today-gift/state/todayGiftSlice';
import {ProfileMenuId} from '../profileMenu/constants';
import {setIsUpdated} from '../profileMenu/profileMenuSlice';
import {useLogin} from '../user/useLogin.hook';
import {useAppConfigQuery} from '../wrapper';
import {getIsMyNewsUpdated} from './getIsMyNewsUpdated';
import {getIsNoticeUpdated} from './getIsNoticeUpdated';
import {getIsTodayGiftUpdated} from './getIsTodayGiftUpdated';

export function useFetchAppConfig() {
  const dispatch = useTypedDispatch();
  const {isLogin} = useLogin();

  const result = useAppConfigQuery(undefined, {
    enabled: isLogin,
    throwOnError: false,
  });
  const appConfig = result.data?.appConfig;

  useEffect(() => {
    if (appConfig) {
      const {appBadge} = appConfig;

      if (appBadge?.myNewsLastAddedDate) {
        dispatch(
          setIsUpdated({
            menuId: ProfileMenuId.Alarm,
            isUpdated: getIsMyNewsUpdated(
              new Date(appBadge.myNewsLastAddedDate)
            ),
          })
        );
      }
      if (appBadge?.noticeLastAddedDate) {
        dispatch(
          setIsUpdated({
            menuId: ProfileMenuId.Notice,
            isUpdated: getIsNoticeUpdated(
              new Date(appBadge.noticeLastAddedDate)
            ),
          })
        );
      }
      if (appBadge?.giftLastAddedDate) {
        dispatch(
          setIsTodayGiftUpdated(
            getIsTodayGiftUpdated(new Date(appBadge.giftLastAddedDate))
          )
        );
      }

      // TODO: 앱 세팅 정보를 처리하는 로직을 추가해야 합니다.
    }
  }, [dispatch, appConfig]);
}
